<template>
    <iframe v-if="url" :src="url" :width="width" :height="height" frameborder="0" id="report"></iframe>
</template>

<script>
	import ApiService from '@/common/api.service'
	import { mapGetters } from 'vuex'

    export default {
        name: 'Informe',
        computed: {
			...mapGetters(['currentUser', 'isAdmin'])
		},
        created () {
            this.init()
        },
        data () {
            return  {
                loading: true,
                url: false,
                width: null,
                height: null
            }
        },
        watch: {
			$route(to) {
				this.loading = true
				this.init()
			}
		},
        methods: {
			init() {
                this.getReport()
                this.customIframe()
            },
			async getReport(){
                if(this.isAdmin){
                    ApiService.post("public/v1", {
                        token: localStorage.getItem("analiticatoken"),
                        single: true,
                        method: 'SELECT',
                        fields: [
                            'informes.url',
                            'informes.width',
                            'informes.height'
                        ],
                        inner: [
                            'reports_projects, report_id, id, informes',
                            'users_projects, project_id, project_id, reports_projects' 
                        ],
                        where: ' informes.id = ' + this.$route.params.informe_id,
                        groupby: ' informes.id',
                        table: 'informes'
                    }).then(response => {
                        if(response.data != 'Algo ha fallado'){
                            if(!response.data){
                                this.$router.push('/dashboard')
                            }
                            this.url = response.data.url
                            this.width = response.data.width
                            this.height = response.data.height
                        }
                        setTimeout(() => {
                            this.loading = false
                        }, 100);
                    })
                }else{
                    ApiService.post("public/v1", {
                        token: localStorage.getItem("analiticatoken"),
                        single: true,
                        method: 'SELECT',
                        fields: [
                            'informes.url',
                            'informes.width',
                            'informes.height'
                        ],
                        inner: [
                            'reports_projects, report_id, id, informes',
                            'users_projects, project_id, project_id, reports_projects' 
                        ],
                        where: ' users_projects.user_id = ' + this.currentUser.id + ' AND informes.id = ' + this.$route.params.informe_id,
                        groupby: ' informes.id',
                        table: 'informes'
                    }).then(response => {
                        if(response.data != 'Algo ha fallado'){
                            if(!response.data){
                                this.$router.push('/dashboard')
                            }
                            this.url = response.data.url
                            this.width = response.data.width
                            this.height = response.data.height
                        }
                        setTimeout(() => {
                            this.loading = false
                        }, 100);
                    })
                }

            }
        }
    }
</script>


<style>
    /* iframe {
        width: 1200px;
        min-height: 100vh;
        height: auto;
    } */
    .custom-main-iframe {
        padding: 0 !important
    }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/iframe.vue